import { useContext, useState } from "react";
import { GlobalConfigContext } from "../../../../context/GlobalConfigContext";
import { parseGraphQLError } from "../../../../utils/commons";
import { useEditPartnerMutation } from "../../Hooks/useEditPartnerMutation";
import PartnerFormModal from "../PartnerForm/PartnerForm";

function EditPartnerModal({ isOpen, closeModal, partner, refetch, id, setToast }) {
  const [partnerData, setPartnerData] = useState(() => partner);
  const [editPartnerMutation, loading] = useEditPartnerMutation();
  const { programMarketConfig } = useContext(GlobalConfigContext);

  const handleCreatePartner = () => {
    const partnerName = partnerData?.name;

    const onSuccess = () => {
      refetch();
      setToast({
        open: true,
        type: "success",
        title: `${partnerName} Edited!`,
        description: "You have just updated a partner!",
      });
      closeModal();
    };
    const onFailure = (error) => {
      setToast({
        open: true,
        type: "error",
        title: `Error on editing ${partnerName}!`,
        description: parseGraphQLError(error),
      });
      setPartnerData(partner);
      closeModal();
    };
    const isEditAllowed = programMarketConfig?.isAssociatedPartnerEditable || false;
    editPartnerMutation(onSuccess, onFailure, partnerData, id, isEditAllowed);
  };

  const onClose = () => {
    setPartnerData(partner);
    closeModal();
  };

  return (
    <PartnerFormModal
      isOpen={isOpen}
      closeModal={onClose}
      partnerData={partnerData}
      setPartnerData={setPartnerData}
      handleMutation={handleCreatePartner}
      loading={loading}
      title="Edit Partner"
      btnTitle="Save"
    />
  );
}

export default EditPartnerModal;
